module.exports = __webpack_public_path__ + "static/img/0014.463ff067.png";